import { render, staticRenderFns } from "./BrandsEditLayer.vue?vue&type=template&id=78eb1b18&scoped=true&"
import script from "./BrandsEditLayer.vue?vue&type=script&lang=js&"
export * from "./BrandsEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandsEditLayer.vue?vue&type=style&index=0&id=78eb1b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb1b18",
  null
  
)

export default component.exports